import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

export default function Videos() {
  const [songs, setSongs] = useState([]);
  useEffect(() => {
    api.get("/songs", { params: { sort: "latest", limit: 60 } })
      .then((r) => setSongs(r.data.filter((s) => s.video_url)));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="mb-12">
        <p className="eyebrow mb-3">Music videos</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight font-light">Watch & keep.</h1>
      </div>
      {songs.length === 0 ? (
        <p className="text-neutral-400 text-sm">No videos yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8">
          {songs.map((s, i) => (
            <Link
              key={s.id}
              to={`/songs/${s.id}`}
              data-testid={`video-${s.id}`}
              className="art-frame rounded-2xl overflow-hidden relative aspect-video group fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <img src={s.cover_url} alt={s.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                <span className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                  <Play size={20} strokeWidth={1.5} className="ml-1" />
                </span>
              </div>
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <p className="font-display text-2xl">{s.title}</p>
                <p className="text-xs opacity-80">{s.artist} · MP4 $2.99</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
